/* eslint-disable jsx-a11y/prefer-tag-over-role */
import { useEffect, useState } from 'react';
import DefaultButton from '../common/default/DefaultButton';
import { deleteCookie, getCookie, setCookie } from 'cookies-next';
import parseWithType from '@/utilites/parse-with-type';
import { useSpiritoryModal } from '@/context/SpiritoryModalProvider';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { CommonEnum } from '@/types/translations/CommonEnum';
import {
  replaceEmojisWithSpan,
  replaceEmojiWithSpan,
} from '@/utilites/strings/strings.utils';
import cookiesConstants from '../../constants/cookies.constants';

export default function FestivalVoucherFloatingIcon() {
  const modal = useSpiritoryModal();
  const { translate } = useTypedTranslation<CommonEnum>('common');

  const [showFestivalVoucher, setShowFestivalVoucher] = useState(false);

  const handleOpenFestivalModal = () => {
    // base text
    const submitText = translate(CommonEnum['festival.got_it']);
    const welcomeTitle = translate(CommonEnum['festival.welcome']);
    const weHope = translate(CommonEnum['festival.we_hope']);
    const exclusiveReward = translate(CommonEnum['festival.exclusive_reward']);
    const enterTheDiscountCode = translate(
      CommonEnum['festival.enter_the_discount_code']
    );
    const dontWait = translate(CommonEnum['festival.dont_wait']);

    // replace emojis

    const submitTextWithEmoji = replaceEmojiWithSpan(
      submitText,
      '🎉',
      'Party Popper'
    );
    const welcomeTitleWithEmoji = replaceEmojiWithSpan(
      welcomeTitle,
      '✨',
      'Sparkles'
    );

    const weHopeWithEmoji = replaceEmojisWithSpan(weHope, [
      { emoji: '🥤', emojiName: 'Cup with Straw' },
      { emoji: '💬', emojiName: 'Speech Balloon' },
    ]);

    const exclusiveRewardWithEmoji = replaceEmojisWithSpan(exclusiveReward, [
      { emoji: '🤩', emojiName: 'Star-Struck' },
      { emoji: '🎁', emojiName: 'Wrapped Gift' },
    ]);

    const enterTheDiscountCodeWithEmoji = replaceEmojisWithSpan(
      enterTheDiscountCode,
      [
        { emoji: '👉', emojiName: 'Backhand Index Pointing Right' },
        { emoji: '📝', emojiName: 'Memo' },
      ]
    );

    const dontWaitWithEmoji = replaceEmojiWithSpan(
      dontWait,
      '💡',
      'Light Bulb'
    );

    modal.setModalType('info');
    modal.setSubmitText(submitTextWithEmoji);
    modal.setTitle(welcomeTitleWithEmoji);

    modal.setBody(
      <>
        <div className="tw-px-8 tw-py-6 tw-text-center tw-space-y-6">
          <p className="tw-text-lg tw-text-gray-700">
            <strong className="tw-text-2xl tw-font-bold tw-text-blue-600">
              {weHopeWithEmoji}
            </strong>
          </p>
          <p className="tw-text-base tw-text-gray-600">
            {exclusiveRewardWithEmoji}
          </p>
          <p className="tw-text-sm tw-text-gray-500 tw-font-medium">
            {enterTheDiscountCodeWithEmoji}
          </p>
          <p className="tw-text-md tw-text-red-500 tw-font-semibold">
            {dontWaitWithEmoji}
          </p>
        </div>
      </>
    );

    modal.openModal();
  };

  useEffect(() => {
    const referralCookie = getCookie(cookiesConstants.COOKIES.REFERRAL_CODE.name);
    const festivalVoucherCookie = getCookie(cookiesConstants.COOKIES.VOUCHER_FESTIVAL.name);

    const parsedReferralCookie = parseWithType<{
      code: string;
      valid: boolean;
      type: 'FRIENDS' | 'INFLUENCER' | null;
      showModal: boolean;
    } | null>(referralCookie || 'null');

    const parsedFestivalVoucherCookie = parseWithType<boolean | null>(
      festivalVoucherCookie || 'null'
    );

    if (
      (parsedReferralCookie === null ||
        parsedReferralCookie.code === 'Whiskyfestival10') &&
      parsedFestivalVoucherCookie !== null
    ) {
      setShowFestivalVoucher(true);
    }

    if (
      (parsedReferralCookie === null ||
        parsedReferralCookie.code === 'Whiskyfestival10') &&
      parsedFestivalVoucherCookie === true
    ) {
      setCookie(cookiesConstants.COOKIES.FESTIVAL_VOUCHER.name, 'false');

      handleOpenFestivalModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (showFestivalVoucher) {
    return (
      <div className="tw-fixed tw-bottom-4 tw-right-4 tw-z-50">
        <DefaultButton
          className="tw-bg-blue-500 tw-rounded-full tw-shadow-lg tw-p-4 tw-flex tw-items-center tw-justify-center tw-transition tw-transform hover:tw-scale-110 focus:tw-outline-none"
          aria-label="Open Festival Voucher"
          onClick={handleOpenFestivalModal}
        >
          <span role="img" aria-label="Party Popper">
            🎉
          </span>
        </DefaultButton>
      </div>
    );
  }

  return null;
}
